var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "transparent",
    cx: 12,
    cy: 12,
    r: 11,
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    stroke: "transparent",
    cx: 11.9996,
    cy: 19.3335,
    r: 1.22222
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M11.9987 16.8891V13.9327C11.9987 12.7786 12.7372 11.754 13.832 11.3891V11.3891C14.9269 11.0241 15.6654 9.99952 15.6654 8.84545V8.21824C15.6654 6.25686 14.0753 4.66684 12.114 4.66684H11.9987C9.97366 4.66684 8.33203 6.30846 8.33203 8.33351V8.33351"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.eaff9de03d6aa85b435b124060ff9f7f.svg";
export { ForwardRef as ReactComponent };